import React from "react";
import { Col, Container, Row } from "react-bs4grid";
import { Form, Formik } from "formik";
import forgotpasswordFormValidationSchema from "./forgotpasswordFormValidationSchema";
import TextField from "../../../formiks/TextField/TextField";
import SubmitButton from "../../../formiks/SubmitButton/SubmitButton";
import FormError from "../../../formiks/FormError/FormError";
import useAppState from "../../../../common/StateMachine/useAppState";

const ForgotPasswordInit = () => {
  const account = useAppState("account");
  const router = useAppState("router");

  return (
    <Container className="pt-32">
      <Row>
        <Col>
          <h1>Password Reset</h1>
        </Col>
      </Row>
      <Row>
        <Col>
          <Formik
            validationSchema={forgotpasswordFormValidationSchema}
            initialValues={{
              email: ""
            }}
            onSubmit={(values, formikActions) => {
              account
                .sendPassWordReset(values.email)
                .then(() => {
                  router.push("/user/forgotdone");
                })
                .catch(error => {
                  formikActions.setStatus(error.response.data.errorMessage);
                  formikActions.setSubmitting(false);
                });
            }}
            render={({ errors, isSubmitting }) => {
              return (
                <Form>
                  <TextField
                    label="Your Email Address"
                    name="email"
                    type="email"
                    placeholder="Please type your email"
                  />

                  <SubmitButton
                    className="btn btn-primary"
                    value="Send Password Link"
                    submittingValue="Sending .."
                  />

                  <FormError />
                </Form>
              );
            }}
          />
        </Col>
      </Row>
    </Container>
  );
};

export default ForgotPasswordInit;
